module.exports = "<div ng-style=\"style\">\n    <ng-transclude ng-if=\"renderExperience\"></ng-transclude>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-ui-components/src/experience/template.html
// module id = ../node_modules/xo-ui-components/src/experience/template.html
// module chunks = 0